import React from "react";

import "./tag.scss";

const Tag = ({ tagText }) => {
  return <div className="tag-style">{tagText}</div>;
};

export default Tag;
